import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AiButton',
  props: {
    theme: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    disabled: _ctx.disabled,
    class: _normalizeClass([{
      'ai-button--gradient': _ctx.theme === 'gradient',
      'ai-button--gradient-primary': _ctx.theme === 'gradient-primary',
      'ai-button--white': _ctx.theme === 'white',
      'ai-button--dark': _ctx.theme === 'dark',
      'ai-button--light-dark': _ctx.theme === 'light-dark',
    }, "ai-button"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})